<template>
  <div class="icon-block">
    <div class="relative">
      <swiper :options="options" :ref="`swiper-${cid}`" class="h-full sm:rounded">
        <swiper-slide v-for="(icon, index) in meta.icons" :key="`icon-${index}`">
          <div class="location__col__link no-underline" @click="clickIcon(icon)">
            <iconCard :icon="icon" />
          </div>
        </swiper-slide>
      </swiper>
      <div :class="`swiper-button-prev swiper-button-prev-${cid}`" slot="button-prev">
        <div class="flex items-center justify-center swiper-button">
          <i class="owl-direction-left"></i>
        </div>
      </div>
      <div :class="`swiper-button-next swiper-button-next-${cid}`" slot="button-next">
        <div class="flex items-center justify-center swiper-button">
          <i class="owl-direction-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
import iconCard from './components/iconCard'
export default {
  name: 'module_Icon',
  props: ['meta'],
  components: {
    iconCard
  },
  data () {
    return {
      cid: this._uid,
      options: {
        loop: false,
        preventInteractionOnTransition: true,
        slideToClickedSlide: false,
        navigation: {
          nextEl: `.swiper-button-next-${this._uid}`,
          prevEl: `.swiper-button-prev-${this._uid}`
        },
        grabCursor: true,
        breakpoints: {
          5000: {
            slidesPerView: 12,
            slidesPerGroup: 12,
            spaceBetween: 40
          },
          991: {
            slidesPerView: 5,
            slidesPerGroup: 5,
            spaceBetween: 16
          },
          767: {
            slidesPerView: 5,
            slidesPerGroup: 5,
            spaceBetween: 16
          },
          375: {
            slidesPerView: 5,
            slidesPerGroup: 5,
            spaceBetween: 16
          }
        },
        on: {
          slideChange () {
            // console.log('slide change')
          },
          reachBeginning () {
            // console.log('reach beginning')
          },
          reachEnd () {
            // console.log('reach end')
          }
        }
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs[`swiper-${this.cid}`].swiper
    }
  },
  methods: {
    clickIcon (icon) {
      if (icon.url) {
        window.open(icon.url)
      }
      window.dataLayer.push({
        event: 'index_icon',
        key: icon.loc
      })
    }
  }
}
</script>
<style lang="sass" scoped>
.icon-block
  @apply mb-32
  .mask
    -webkit-mask-image: linear-gradient(270deg, transparent, black, transparent)
    mask-image: linear-gradient(270deg, transparent 0%, white 5%, white 95%, transparent 100%)
</style>
<style lang="sass">
.icon-block
  .swiper-container
    @apply px-16
    @screen sm
      @apply px-0
    .swiper-slide
      max-width: 57px
      @screen md
        max-width: 64px
  .swiper-button-prev, .swiper-button-next
    @apply h-full outline-none mt-0 pin-t #{!important} flex
    width: 50px
    background-image: none !important
    z-index: 8
    .swiper-button
      @apply outline-none #{!important} rounded-full bg-grey-lightest absolute
      top: 50% !important
      transform: translateY(-50%) !important
      width: 35px !important
      height: 35px !important
      i[class*=owl-direction]
        @apply text-grey-darkest
        font-size: 18px
  .swiper-button-prev
    @apply justify-start
    @apply hidden
    left: 0px !important
    background: transparent !important
    background-image: linear-gradient(270deg, transparent 0%, white 30%) !important
    // @screen sm
    //   left: -17.5px !important
    @screen md
      @apply flex
  .swiper-button-next
    @apply justify-end
    @apply hidden
    right: 0px !important
    background: transparent !important
    background-image: linear-gradient(90deg, transparent 0%, white 30%) !important
    // @screen sm
    //   right: -17.5px !important
    @screen md
      @apply flex
  .swiper-button-disabled
    @apply hidden
</style>
